export const MOBILE_LOGO_FALLBACK = "/assets/images/card-img-1.svg";
export const FAIRGATE_LOGO = "/assets/images/fairgate_N_Logo.svg";
export const AVAILIO_LOGO = "/assets/images/logo/availio_logo_v2.svg";
export const BANNER_IMAGE = "/assets/images/top-banner1.jpg";
export const NO_ORGANISATION_IMG = "/assets/images/no_organisation_found.png";
export const TWINT_LOGO = "/assets/images/logo/twint.logo.webp";
